import * as React from 'react'

import { styled, spacing } from '@thg-commerce/enterprise-theme'
import {
  Separator,
  ArticlePreview,
  ArticlePreviewProps,
} from '@thg-commerce/gravity-elements'
import { i18n } from '@thg-commerce/enterprise-core'
import { Grid, GridItem } from '@thg-commerce/gravity-system'

import {
  Category as CategoryType,
  Tag as TagType,
  PostAuthor as PostAuthorType,
} from '../../types'
import { CategoryHeaderRenderer } from '../../renderer/CategoryHeaderRenderer'

export interface CategoryProps {
  category: CategoryType | TagType | PostAuthorType
  categoryPosts: ArticlePreviewProps[] | undefined | null
  hasWebP: boolean
}

const StyledGrid = styled(Grid)`
  margin: 0 auto ${spacing(6)};
  max-width: ${(props) => props.theme.site.siteWidth};
`

const StyledSeparator = styled(Separator)`
  margin: ${spacing(4)} 0;
`

export const Category = (props: CategoryProps) => {
  const i18nText = {
    noPosts: i18n('general.category.noposts'),
  }
  const posts =
    props.categoryPosts &&
    props.categoryPosts.map((previewProps, index) => {
      return (
        <React.Fragment key={previewProps.articleUrl}>
          <StyledSeparator />
          <ArticlePreview
            {...previewProps}
            direction="row"
            testId="post-card-testid"
            image={{ ...previewProps.image, lazy: index < 4 ? false : true }}
          />
        </React.Fragment>
      )
    })
  return (
    <React.Fragment>
      <CategoryHeaderRenderer
        hasWebP={props.hasWebP}
        category={props.category}
      />
      <StyledGrid>
        <GridItem colSpan={[10, 12, 6, 6]} colStart={[2, 1, 4, 4]}>
          {posts && posts.length > 0 ? posts : <p>{i18nText.noPosts}</p>}
        </GridItem>
      </StyledGrid>
    </React.Fragment>
  )
}
